module.exports = "/_next/static/images/12b4839017a840db34b6afa86b144d9a-website-thumb-large.jpg.webp";